module.exports = __webpack_public_path__ + "img/information.4283870.png";